import { observable, action } from 'mobx';

export class TaskStore {
  @observable tasks: TaskInfo[] = [];

  @action
  handleUpdateTasks(tasks: TaskInfo[]) {
    this.tasks = tasks;
  }
}

export const taskStore = new TaskStore();
